import AuthMiddleware from "@/middleware/auth"

const DataEntryTemplateGeneration = () =>
  import(
    /* webpackChunkName: "data-entry-template-generation" */ "@/components/reports/DataEntryTemplateGeneration"
  )

const DataEntryTemplateGenerationRouter = [
  {
    path: "/data-entry-template-generation",
    name: "DataEntryTemplateGeneration",
    component: DataEntryTemplateGeneration,
    beforeEnter: AuthMiddleware.user,
    meta: { title: "DATA ENTRY TEMPLATE GENERATION" },
  },
]

export { DataEntryTemplateGenerationRouter }